import type { Resource } from '../../';
export const general_previousSlide: Resource = {"default":"Previous Slide"};
